import { Container } from "../Container/Container";
import { Tag } from "../Tag";
import { List } from "../Container/List/List";

export class App extends Container {
    public addToContainer(tag: Tag) {
        this.getContainer().addItem(tag);
    }

    protected getContainer(): List {
        return this.get("--container");
    }

    protected createSelf() {
        super.createSelf();
        const container = new List();
        this.addToData("--container", container);
        this.appendChild(container);
    }
}
